import {
  dimensiondata_1_tetelek_group_w200_dimension_1_2_3_row,
  dimensiondata_2_termekek_group_1_2_3_first_column_expanded,
  KTOE_value_1_data_precision_year_summary,
  TJ_value_2_data_precision_year_summary,
  year_row_expanded,
  order_1,
  order_2
} from '../../fields';
import { PivotGridConfig } from '../../utils/pivot-grid-config';

export const eurostatEnergiamerlegConfig: PivotGridConfig = {
  showChart: false,
  treeHeaderLayout: true,
  filterYear: {},
  options: {
    store: {
      version: 4,
      type: 'odata',
      url: 'odata/v4/public/EurostatEnergiamerleg',
      select: ['date', 'dimension_1', 'dimension_2', 'value_1', 'value_2'],
      beforeSend: (e: any) => {
        e.headers = {
          Accept: 'application/json;odata.metadata=none',
        };
      },
    },
    retrieveFields: false,
    fields: [
      year_row_expanded,
      ...dimensiondata_1_tetelek_group_w200_dimension_1_2_3_row,
      ...dimensiondata_2_termekek_group_1_2_3_first_column_expanded,
      KTOE_value_1_data_precision_year_summary,
      TJ_value_2_data_precision_year_summary,
      order_1,
      order_2
    ],
  },
};
